import { MapPin, Layers } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/context/AuthContext";
import { useDepot } from "@/context/DepotContext";

const ALL = "all";

// Header control: company logins pick a depot (or All depots); depot logins see their depot name.
export const DepotSwitcher = () => {
  const { user } = useAuth();
  const { depots, depot, setDepot, isAdmin } = useDepot();
  if (user?.role !== "coordinator") return null;

  if (!isAdmin) {
    return (
      <span data-testid="depot-badge" className="inline-flex items-center gap-1.5 rounded-full border border-primary/30 bg-primary/5 text-primary px-3 h-9 text-sm font-medium max-w-[160px]">
        <MapPin className="w-4 h-4 shrink-0" /> <span className="truncate">{user?.depot_name || "Depot"}</span>
      </span>
    );
  }
  if (!depots.length) return null;

  return (
    <Select value={depot || ALL} onValueChange={(v) => setDepot(v === ALL ? "" : v)}>
      <SelectTrigger data-testid="depot-switcher" className="h-9 w-[150px] sm:w-[180px] rounded-full border-primary/30 text-sm font-medium">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ALL} data-testid="depot-switcher-all">
          <span className="inline-flex items-center gap-1.5"><Layers className="w-3.5 h-3.5" /> All depots</span>
        </SelectItem>
        {depots.map((d) => (
          <SelectItem key={d.id} value={d.id} data-testid={`depot-switcher-${d.id}`}>
            <span className="inline-flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" /> {d.name}</span>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
